<template>
  <div class="evaluationcontent">
    <img class="bg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/evaluation/bg.png">
    <img class="arrow" @click="back" src="../../../assets/images/evaluation/left.png">
    <div class="topBox">
      <img class="photo" src="../../../assets/images/evaluation/photo.png">
      <div class="text">基于专业层面的知识和技能，素质层面的素养和动机，构建个人精准人才画像！</div>
      <img class="irregular" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/evaluation/irregular.png">
    </div>
    <div class="middleBox">
      <img class="photo" src="../../../assets/images/evaluation/major.png">
      <div class="text">掌握基本技能、专业知识点，为职业道路赋能</div>
      <div class="statistics">
        <img class="photo" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/evaluation/statistics.png">
      </div>
      <!-- <van-button class="lastbutton">自然语言处理实战</van-button> -->
      <van-button class="goStudy" @click="checkUserCanByGoods(1)">去学习</van-button>
      <van-button class="goExam" @click="checkUserCanByGoods(2)">去考试</van-button>
    </div>
    <div class="bottomBox">
      <img class="bgwhite" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/evaluation/bgwhite.png">
      <img class="photo" src="../../../assets/images/evaluation/work.png">
      <div class="text">维度指标体系：追求新意·严谨型·智慧型·研究型·成就感·智力刺激</div>
      <img class="leida" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/evaluation/leidatu.png">
    </div>
  </div>
</template>
<script>
import api from "../../../api/modules/evaluation"
import md5 from 'js-md5';
export default {
  name: "evaluation",
  data() {
    return {
      show: false,
      courseId:null,
        goodsId:null,
        examId:null,
    };
  },
  mounted() {
      this.goStudy()
    //   this.goExam()
  },
  methods: {
    back(){
      this.$router.go(-1)
    },
    async judgeHastraining(id){
      let params = {
          //列表
          trainId: id
      };
      await this.$api.training.findUserTrain({ params }).then(res => {
          if(res.success) {
            this.$router.push({
              path:`/learning/Details?id=${id}`
            })
          }
      })
    },
    checkUserCanByGoods(type){ //查看商品是否购买；
            let params = {
                goodsId:this.goodsId
            }
            this.$api.home.checkUserCanByGoods({params}).then(data =>{
                if(data.data == true){
                    this.$toast("您尚未购买课程，先去购买课程吧");
                    this.$router.push({path: '/gongxin_coursePay'})
                }else {
                    if(type === 1){
                        // this.goStudy();
                        this.judgeHastraining(this.courseId);

                    }else {
                        this.judgeHastraining(this.examId);

                        // this.goExam()
                    }
                }
        })
    },
    goStudy(){
      this.$api.home.findSaleGoods().then(res=>{
        this.courseId=res.data.referId
        this.goodsId = res.data.id
        this.goExam()
      })
    },
    goExam(){
      this.$api.home.findGoodsGiftByGoodsId(this.goodsId).then(res=>{
        this.examId=res.data
      })
    }
  },
};
</script>
<style lang="less">
@import url("../asset/css/evaluation");
</style>